export enum CookieKeys {
    MODAL_DISMISSED = 'action_modal_dismissed',
    PREFERRED_LANGUAGE = 'language',
    PREFERRED_CURRENCY = 'CurrencyDisplay',
    MODAL_EARLY_CHECKOUT = 'action_modal_early_checkout',
}

export enum StorageKeys {
    NONCE = 'nonce',
    STATE = 'state',
    REFERRER = 'referrer',
    LEGACY_TOKEN = 'legacy_token',
    ACCESS_TOKEN = 'access_token',
    IDENTITY_TOKEN = 'id_token',
    RESERVATION_ID = 'reservation_id',
    CONFIRMATION_CODE = 'confirmation_code',
    AUTH_METHOD = 'auth_method',
    USER_TYPE = 'user_type',
    KOUNT_SESSION_ID = 'kount_session_id',
}
